var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"xl","title":"Agregar al carrito","hide-footer":"","id":"add-to-cart-modal"}},[_c('article-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }